import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import type { RegionProps } from "forms/fields/ContactData/types";
import FormItem from "forms/fields/FormItem";
import { predefinedFields } from "types/predefinedFields";
import { Select } from "ui/Select/Select";
import { FormField } from "uiShadcn/form";
export default function Region(t0) {
  const $ = _c(9);
  const {
    control,
    data,
    options
  } = t0;
  const {
    formatMessage
  } = useIntl();
  const isRequired = data.type === "integer";
  let t1;
  if ($[0] !== options) {
    t1 = Object.entries(options).map(_temp);
    $[0] = options;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dictionary = t1;
  let t2;
  if ($[2] !== dictionary || $[3] !== formatMessage || $[4] !== isRequired) {
    t2 = t3 => {
      const {
        field
      } = t3;
      return <FormItem label={formatMessage({
        id: "region"
      })} required={isRequired}><Select ref={field.ref} dataTestId="Select-region" defaultValue={field.value} onValueChange={field.onChange} required={isRequired} options={dictionary} placeholder={formatMessage({
          id: "select"
        })} /></FormItem>;
    };
    $[2] = dictionary;
    $[3] = formatMessage;
    $[4] = isRequired;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== control || $[7] !== t2) {
    t3 = <FormField control={control} name={predefinedFields.region} render={t2} />;
    $[6] = control;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
function _temp(t0) {
  const [value, label] = t0;
  return {
    key: value,
    value: label
  };
}